module.exports = __webpack_public_path__ + "img/2.4de8fda7.png";